module.exports = __webpack_public_path__ + "img/Logo_footer.20f0b92e.svg";